// import './SectionServices.scss';
// import { Button, Card } from 'antd';
// import Aos from 'aos';
// import React, { useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// const SectionServices = ({ t, titleBtn, data, isLoading }) => {
//   const { currentLang } = useSelector((state) => state.user);
//   const navigate = useNavigate();
//   console.log(data, 'data from serve');

//   useEffect(() => {
//     Aos.init({
//       duration: 1000,
//     });
//   }, []);
//   const services = [
//     {
//       number: '01',
//       title: 'VR',
//       supTitle: 'Virtual Reality',
//       description:
//         'A fully immersive digital experience simulating real or imaginary environments using specialized hardware and software',
//     },
//     {
//       number: '02',
//       title: 'MR',
//       supTitle: 'Mixed Reality',
//       description:
//         ' blend of real and virtual worlds where physical and digital objects coexist and interact in real-time, enhancing user engagement',
//     },
//     {
//       number: '03',
//       title: 'AR',
//       supTitle: 'Augmented Reality ',
//       description:
//         'Digital content overlaid onto the real world through a smartphone, tablet, or smart glasses, enhancing what you see with virtual objects/information  ',
//     },
//     // {
//     //   number: '05',
//     //   supTitle: t.Prototyping,
//     //   description: t.descriptionServicesCard4,
//     // },
//   ];
//   // const services = [
//   //   {
//   //     number: '01',
//   //     title: t.VR,
//   //     supTitle: t.Development,
//   //     description: t.descriptionServicesCard1,
//   //   },
//   //   {
//   //     number: '02',
//   //     title: t.MR,
//   //     description: t.descriptionServicesCard2,
//   //   },
//   //   {
//   //     number: '03',
//   //     title: t.AR,
//   //     supTitle: t.Development,
//   //     description: t.descriptionServicesCard3,
//   //   },
//   //   // {
//   //   //   number: '04',
//   //   //   title: t.UIUX,
//   //   //   supTitle: t.Design,
//   //   //   description: t.descriptionServicesCard4,
//   //   // },
//   //   {
//   //     number: '05',
//   //     supTitle: t.Prototyping,
//   //     description: t.descriptionServicesCard4,
//   //   },
//   // ];
//   return (
//     <div className="section-services">
//       <div className="container">
//         <div className="content">
//           <h2 className="title-services" data-aos="flip-down">
//             {t.MainServices}
//           </h2>
//           <div className="services-cards">
//             {services.map((service, index) => {
//               return (
//                 <div
//                   className="service-card-container"
//                   key={index}
//                   data-aos={index % 2 ? 'fade-right' : 'fade-left'}
//                   data-aos-delay={index * 100}
//                 >
//                   <Card className="service-card">
//                     <h4 className="number-card">{service.number}</h4>
//                     <div className="content-card">
//                       <h2 className="title-card">{service.title}</h2>
//                       {service.supTitle && (
//                         <h3
//                           className="sub-title-card"
//                           style={{
//                             letterSpacing:
//                               currentLang === 'ar' ? '0px' : '-3px',
//                           }}
//                         >
//                           {service.supTitle}
//                         </h3>
//                       )}
//                     </div>
//                     <p className="description-card">{service.description}</p>
//                   </Card>
//                 </div>
//               );
//             })}
//           </div>
//           <div
//             className="btn-hero"
//             style={{
//               marginTop: '80px',
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//             }}
//           >
//             {titleBtn === 'Contact Us' ? (
//               <Button className="btn-hero" type="primary">
//                 <a href="#contact">{titleBtn}</a>
//               </Button>
//             ) : (
//               <Button
//                 className="btn-hero"
//                 type="primary"
//                 onClick={() =>
//                   navigate(
//                     `${currentLang === 'en' ? '/services' : '/ar/services'}`
//                   )
//                 }
//               >
//                 {titleBtn}
//               </Button>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SectionServices;
import './SectionServices.scss';
import { Button, Card, Skeleton } from 'antd'; // استيراد Skeleton
import Aos from 'aos';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const SectionServices = ({ t, titleBtn, data, isLoading }) => {
  const { currentLang } = useSelector((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    Aos.init({
      duration: 1000,
    });
  }, []);

  const loadingCards = Array.from({ length: 3 }).map((_, index) => (
    <div
      className="service-card-container loading-card-container"
      key={`loading-${index}`}
      data-aos={index % 2 ? 'fade-right' : 'fade-left'}
      data-aos-delay={index * 100}
    >
      <Card className="service-card loading-card">
        <h4 className="number-card">
          <Skeleton.Input active size="small" style={{ width: 40 }} />
        </h4>
        <div className="content-card">
          <h2 className="title-card">
            <Skeleton active paragraph={{ rows: 1 }} />
          </h2>
          <h3
            className="sub-title-card"
            style={{
              letterSpacing: currentLang === 'ar' ? '0px' : '-3px',
            }}
          >
            <Skeleton active paragraph={{ rows: 1 }} />
          </h3>
        </div>
        <p className="description-card">
          <Skeleton active paragraph={{ rows: 2 }} />
        </p>
      </Card>
    </div>
  ));

  return (
    <div className="section-services">
      <div className="container">
        <div className="content">
          <h2 className="title-services" data-aos="flip-down">
            {t.MainServices}
          </h2>
          <div className="services-cards">
            {isLoading
              ? loadingCards
              : data?.map((service, index) => {
                  const serviceNumber = (index + 1).toString().padStart(2, '0');
                  return (
                    <div
                      className="service-card-container"
                      key={index}
                      data-aos={index % 2 ? 'fade-right' : 'fade-left'}
                      data-aos-delay={index * 100}
                    >
                      <Card className="service-card">
                        <h4 className="number-card">{serviceNumber}</h4>
                        <div className="content-card">
                          <h2 className="title-card">{service?.title}</h2>
                          {service?.name && (
                            <h3
                              className="sub-title-card"
                              style={{
                                letterSpacing:
                                  currentLang === 'ar' ? '0px' : '-3px',
                              }}
                            >
                              {service?.name}
                            </h3>
                          )}
                        </div>
                        <p className="description-card">
                          {service?.description}
                        </p>
                      </Card>
                    </div>
                  );
                })}
          </div>
          <div
            className="btn-hero"
            style={{
              marginTop: '80px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {titleBtn === 'Contact Us' ? (
              <Button className="btn-hero" type="primary">
                <a href="#contact">{titleBtn}</a>
              </Button>
            ) : (
              <Button
                className="btn-hero"
                type="primary"
                onClick={() =>
                  navigate(
                    `${currentLang === 'en' ? '/services' : '/ar/services'}`
                  )
                }
              >
                {titleBtn}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionServices;
